module.exports = __webpack_public_path__ + "img/med-in-mind-member-of-medictum.9b99dcd0.svg";